import _jsx from '@babel/runtime/helpers/jsx';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import { applyClasses, entries, arrayIncludes, hyphenatedbem } from '@vpp-frontend-components/common';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { componentEnhance } from '@vpp-frontend-components/component-enhance';
const _excluded = ["as", "alignment", "withDangerous", "text", "color", "bg_color", "font_family", "font_size", "className", "margin", "accessibilityText", "children"];
const createMarkup = text => ({
  __html: text
});
const allowedForwardedProps = ['href', 'target', 'id', 'onClick', 'data-testid'];
const filterForwardProps = function () {
  let forwardProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return entries(forwardProps).reduce((acc, _ref) => {
    let [name, value] = _ref;
    if (arrayIncludes(allowedForwardedProps, name)) {
      acc[name] = value;
    }
    if (name === 'for') {
      acc.htmlFor = value;
    }
    return acc;
  }, {});
};

/**
 * StyledLabel component
 * Map from BE props to FE naming
 * @type {import('../index').StyledLabel}
 */
const StyledLabel = _ref2 => {
  let {
      as = 'p',
      alignment = null,
      withDangerous = false,
      text = null,
      color = null,
      bg_color = null,
      font_family = 'REGULAR',
      font_size = null,
      className = '',
      margin = null,
      accessibilityText = null,
      children = null
    } = _ref2,
    forwardProps = _objectWithoutProperties(_ref2, _excluded);
  const classes = applyClasses({
    size: font_size,
    family: font_family,
    alignment,
    color,
    bg_color,
    className,
    margin
  });
  const Element = as;
  const filteredForwardedProps = filterForwardProps(forwardProps);
  if (withDangerous) {
    return /*#__PURE__*/React.createElement(Element, _extends({
      className: classes
    }, filteredForwardedProps, {
      dangerouslySetInnerHTML: createMarkup(text)
    }));
  }
  return /*#__PURE__*/React.createElement(Element, _extends({
    className: classes
  }, filteredForwardedProps), text, accessibilityText && /*#__PURE__*/_jsx("span", {
    className: "ui-pdp--hide"
  }, void 0, accessibilityText), children);
};
const labelToProps = props => _objectSpread(_objectSpread({}, props.label), {}, {
  text: componentEnhance.jsx(props.label.text, props.label.values),
  className: hyphenatedbem(props.id),
  alignment: props.alignment,
  as: 'h2'
});
export { StyledLabel, labelToProps };
